import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { ADD_MOBILE_CONFIGURATION, GET_MOBILE_CONFIGURATION } from "../Constants";
import { AddMobileConfigurationSuccess, AddMobileConfigurationFailure, GetMobileConfigurationSuccess, GetMobileConfigurationFailure } from "../Actions/mobileConfigurationActions";
import { logout } from "../../utils";

function* mobileConfigurationRequest(actions) {
  try {
    const headers = { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` };
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/edit_url`,
      {
        id: actions.payload.id,
        search_url: actions.payload.search_url,
      },
      { headers: headers }
    );
    if (res.status === 200) {
      yield put(AddMobileConfigurationSuccess(res.data));
    } else yield put(AddMobileConfigurationFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddMobileConfigurationFailure(e));
  }
}

function* getMobileConfigurationRequest() {
  try {
    const headers = { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` };
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/search_url`, { headers: headers });
    if (res.status === 200) {
      yield put(GetMobileConfigurationSuccess(res.data));
    } else yield put(GetMobileConfigurationFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetMobileConfigurationFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(ADD_MOBILE_CONFIGURATION, mobileConfigurationRequest);
  yield takeLatest(GET_MOBILE_CONFIGURATION, getMobileConfigurationRequest);
}

export default function* MobileConfigurationSaga() {
  yield all([actionWatcher()]);
}
